import { render, staticRenderFns } from "./Creditos.vue?vue&type=template&id=69b14934"
import script from "./Creditos.vue?vue&type=script&lang=js"
export * from "./Creditos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports